import types from '../types'

const modeLoaded = (modeId) => ({
  type: types.MODE_LOADED,
  payload: modeId,
})

const modeLoading = (modeId) => ({
  type: types.MODE_LOADING,
  payload: modeId,
})

const modePolling = (modeId) => ({
  type: types.MODE_POLLING,
  modeId,
})

const setTabApiMessages = (modeId, messages, errors) => ({
  type: types.API_MESSAGES_SET,
  messages,
  errors,
  modeId,
})

const increasePage = (modeId, isOutbound) => ({
  type: types.PAGE_INCREASE,
  payload: modeId,
  isOutbound,
})

const noResultsForTime = (modeId, isOutbound) => ({
  type: types.NO_RESULTS_FOR_TIME,
  modeId,
  isOutbound,
})

const noResultsForFerryType = (modeId) => ({
  type: types.NO_RESULTS_FOR_FERRY_TYPE,
  modeId,
})

const noMoreResults = (isOutbound, modeId) => ({
  type: types.NO_MORE_RESULTS,
  isOutbound,
  modeId,
})

export default {
  modeLoaded,
  modeLoading,
  modePolling,
  setTabApiMessages,
  increasePage,
  noResultsForTime,
  noResultsForFerryType,
  noMoreResults,
}
